import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import Github from "./Github";
import Techstack from "./Techstack";
import Aboutcard from "./AboutCard";
import newAboutImg from "../../Assets/myavatar.png"; // Import the new image
import Toolstack from "./Toolstack";
import "./about.css"; // Import the CSS file for styles

function About() {
  return (
    <Container fluid className="about-section" >
      <Particle /> {/* Ensure Particle component is positioned correctly */}
      <Container>
        <Row className="about-row">
          <Col md={7} className="about-col">
            <h1 className="about-heading">
              Know Who <strong className="purple">I'M</strong>
            </h1>
            <Aboutcard />
          </Col>
          <Col md={5} className="about-col">
            <img src={newAboutImg} alt="about" className="img-fluid" />
          </Col>
        </Row>
        <h1 className="project-heading">
          Professional <strong className="purple">Skillset </strong>
        </h1>
        <Techstack />
        <h1 className="project-heading">
          <strong className="purple">Tools</strong> I use
        </h1>
        <Toolstack />
        <Github />
      </Container>
    </Container>
  );
}

export default About;
